import { gql } from 'graphql-request'

export const CREATE_BOOK_CHAPTER = gql`
  mutation CreateBookChapter($createBookChapterInput: CreateBookChapterInput!) {
    createBookChapter(createBookChapterInput: $createBookChapterInput) {
      id
    }
  }
`
